module.exports = import("https://cdn.jsdelivr.net/npm/marked@4.0.12/lib/marked.esm.js");;